// extracted by mini-css-extract-plugin
export default {"oops":"Oops_oops__XroG3","logo":"Oops_logo__OWTYj","message":"Oops_message__zEfjD","retry":"Oops_retry__aQAIH"};